var React = require('react');

function MenuLeftBlackInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.995117 0H10.9999L10.9999 1.99039H0.995118L0.995117 0Z","fill":"#091034","key":0}),React.createElement("path",{"d":"M0.995117 7.00456H20.9951V8.99495H0.995118L0.995117 7.00456Z","fill":"#091034","key":1}),React.createElement("path",{"d":"M0.995117 14.0096L0.995118 16H14.998V14.0096H0.995117Z","fill":"#091034","key":2})]);
}

MenuLeftBlackInline.defaultProps = {"width":"21","height":"16","viewBox":"0 0 21 16","fill":"none"};

module.exports = MenuLeftBlackInline;

MenuLeftBlackInline.default = MenuLeftBlackInline;
